<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WDFEXk/tc-custom/9780253060655.jpg?1726273531883" alt="This image is the cover for the book Amtrak, America's Railroad, Railroads Past and Present"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amtrak, America's Railroad, Railroads Past and Present
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Discover the story of Amtrak, America's Railroad, 50 years in the making</b>.</p><p>In 1971, in an effort to rescue essential <i>freight</i> railroads, the US government founded Amtrak. In the post–World War II era, aviation and highway development had become the focus of government policy in America. As rail passenger services declined in number and in quality, they were simultaneously driving many railroads toward bankruptcy. Amtrak was intended to be the solution.</p><p>In <i>Amtrak, America's Railroad: Transportation's Orphan and Its Struggle for Survival</i>, Geoffrey H. Doughty, Jeffrey T. Darbee, and Eugene E. Harmon explore the fascinating history of this popular institution and tell a tale of a company hindered by its flawed origin and uneven quality of leadership, subjected to political gamesmanship and favoritism, and mired in a perpetual philosophical debate about whether it is a business or a public service. Featuring interviews with former Amtrak presidents, the authors examine the current problems and issues facing Amtrak and their proposed solutions.</p><p>Created in the absence of a comprehensive national transportation policy, Amtrak manages to survive despite inherent flaws due to the public's persistent loyalty. <i>Amtrak, America's Railroad</i> is essential reading for those who hope to see another fifty years of America's railroad passenger service, whether they be patrons, commuters, legislators, regulators, and anyone interested in railroads and transportation history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoffrey H. Doughty, Jeffrey T. Darbee, Eugene E. Harmon
      </h2>
      
      <p class="authorDescription body article"><P><P>Geoffrey Doughty joined the Operating department of Maine Central Railroad in 1974. After stints in Accounting and Engineering Departments, he was promoted to the Safety department in 1982 following the railroad's consolidation with the Boston & Maine and the Delaware & Hudson under Guilford ownership. He was later a safety consultant and safety director for two New England trucking associations.</P><P>Jeffrey Darbee has recently completed a 46-year career in historic preservation and is the author of several books on historic architecture and railroad history. He resides in Columbus, Ohio. </P><P>Now retired, Eugene Harmon worked for two major railroads in freight marketing and became an independent contractor in corporate restructuring, logistics management and market development. He has worked in Thailand on passenger and freight marketing and strategic development, and he has traveled by rail on four continents. He is a member of The Lexington Group where he has made a variety of presentations on logistics and transportation.</P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c54feb40